import { FunctionComponent, memo } from 'react';

// @Components
import Image from '@Components/Utils/Image';
import { useViewDetected } from '@Components/Utils/ViewDetected';
import DoctorQuestion, { DoctorQuestionProps } from '@Components/UI/DoctorQuestion';

// Lib
import { getAttachmentAvatar } from '@Libs/utils';

// NPM
import Moment from 'moment';
import classnames from 'classnames';

// Styles
import styles from './AnswerCard.module.scss';

interface AnswerCardProps {
    image?: string;
    title?: string;
    content?: string;
    className?: string;
    doctorProfile?: any;
    imgClassName?: string;
    answerClassName?: string;
    imagePosition?: 'top' | 'left';
}

const AnswerCard: FunctionComponent<DoctorQuestionProps & AnswerCardProps> = memo(
    ({ image, title, content, className, imgClassName, imagePosition, doctorProfile, answerClassName }) => {
        const { deviceType } = useViewDetected();
        const isMobile = deviceType !== 'desktop';

        const imageClassName = classnames([styles.image, imgClassName]);
        const titleClassName = classnames([styles.title, answerClassName]);
        const wrapperClassName = classnames([
            styles.wrapper,
            { [styles.image_left]: imagePosition === 'left' && !isMobile, [styles.mobile]: isMobile },
            className,
        ]);

        // Declare
        const { id, profile } = doctorProfile || {};
        const avatar = getAttachmentAvatar(id, 'doctor');
        const { average } = profile?.rating || 0;
        const { fullName: doctorName, graduateYear } = profile || {};
        const experience = Moment().year() - graduateYear;

        return (
            <div className={wrapperClassName}>
                {image && <Image className={imageClassName} src={image} width={'100%'} height={'auto'} />}

                <div className={styles.info_wrapper}>
                    {title && <div className={titleClassName}>{title}</div>}

                    {!title && content && (
                        <div className={styles.question}>
                            <span>{content}</span>
                        </div>
                    )}
                    <DoctorQuestion {...{ avatar, average, doctorName, experience }} className={styles.doctor} />
                </div>
            </div>
        );
    },
);

AnswerCard.defaultProps = {
    image: '',
    title: '',
    content: '',
    className: '',
    imgClassName: '',
    answerClassName: '',
};

export default AnswerCard;
